<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <h1 class="font-bold-display-medium">Mitgliederbereiche</h1>
    <button
      class="inwi-icon-text-button-medium-primary"
      (click)="openBulkUploadModal()">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-cloud-arrow-up"></i>
        </div>
        <div class="button-text">Datei in Bereiche hochladen</div>
      </div>
    </button>
  </div>

  <div class="table">
    <app-custom-table
      titleMultipleResults="Mitgliederbereiche"
      titleSingleResult="Mitgliederbereich"
      titleResultSuffix="verfügbar"
      [dataSource$]="dataSource$"
      [columns]="columns"
      [pageSizeOptions]="[5, 10, 25, 50, 100]"
      [pageSize]="50"
      [fuzzySearch]="true"
      noDataIcon="fa-folder"
      noDataMessage="Es gibt derzeit keine Mitgliederbereiche."
      noSearchResultsIcon="fa-folder"
      noSearchResultsMessage="Es gibt keine Mitgliederbereiche, die mit deinen Suchkriterien übereinstimmen."
      [tableHeaderButton]="tableHeaderButton"
      [dataSource$]="dataSource$"
      [isLoading]="loading"></app-custom-table>
  </div>
</div>
